// Versturen van leadformulieren (contactformulier en brochure-download).
//
// De formulieren posten naar FormSubmit, een form-naar-e-mail dienst zonder
// account: inzendingen komen binnen op info@puntuit.nl. Eenmalige activatie
// vereist — na de allereerste inzending stuurt FormSubmit een bevestigings-
// mail naar info@puntuit.nl; pas na het klikken op die link komen inzendingen
// door. Wil je later naar een andere dienst (bijv. Formspree of een eigen
// endpoint), dan hoeft alleen deze constante en eventueel de payload mee te
// veranderen.
const FORM_ENDPOINT = 'https://formsubmit.co/ajax/info@puntuit.nl';

export async function submitLead(
  fields: Record<string, string>,
  { subject }: { subject: string }
): Promise<boolean> {
  try {
    const res = await fetch(FORM_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        ...fields,
        _subject: subject,
        _template: 'table',
        _captcha: 'false',
      }),
    });
    if (!res.ok) return false;
    const data: unknown = await res.json().catch(() => null);
    if (!data || typeof data !== 'object') return false;
    const success = (data as { success?: string | boolean }).success;
    return success === true || success === 'true';
  } catch {
    return false;
  }
}
